import { FormulaireRechercheModel } from '../types/formulaireRechercheModel'
import axios from 'axios'

export const getResultatRecherche = (valeurFormulaire?: FormulaireRechercheModel) => axios.post('/api/ac_residence/information/rechercheOffre', valeurFormulaire)
	.then((response) => response.data)